export const MINIMUM_AGE = 18;

export const DEFAULT_STRINGS = {
    CreateAPassword: 'Create a password',
    AlreadyHaveAccount: 'Already have one? Log in.',
    Title: 'Create an account',
};

export const LASER_STRINGS = {
    ...DEFAULT_STRINGS,
    AlreadyHaveAccount: 'Already have a Zocdoc account? Log in.',
    CreateAPassword: 'Create a Zocdoc password',
    Title: 'Book now for free',
};

export const SOCIAL_STRINGS = {
    ...DEFAULT_STRINGS,
    AlreadyHaveAccount: 'Log in',
    AlreadyHaveAccountText: ' to skip.',
    Title: 'Complete your profile',
};

export const SOFT_LOGIN_STATE = 1;
